import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { DeviceModel } from 'src/app/models/entities/device-model';
import { DeviceModelService } from 'src/app/services/device-model.service';

@Component({
  selector: 'app-device-model',
  templateUrl: './device-model.component.html',
  styleUrls: ['./device-model.component.css']
})
export class DeviceModelComponent implements OnInit {

  destroy$ = new Subject<void>();
  deviceModels$: Observable<DeviceModel[]>;
  deleteModal: boolean;
  deviceModelId: number;
  @ViewChild('dt', { static: false }) dt: any;

  
  constructor(private deviceModelService: DeviceModelService, private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.getList();
  }

  getList(){
    this.deviceModels$ = this.deviceModelService.getList().pipe(map(result => result.data));
  }

  applyFilterGlobal($event: Event, stringVal: string) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, 'contains');
  }

  showDeleteModal(deviceModelId: number) {
    this.deleteModal = true;
    this.deviceModelId = deviceModelId;
  }

  deleteDeviceModel() {
    this.deleteModal = false;
    this.deviceModelService.delete(this.deviceModelId).pipe(takeUntil(this.destroy$)).subscribe(
      result => {
        this.toastrService.success(result.message, "BAŞARILI!");
        this.getList();
      },
      er => {
        this.toastrService.error(er.error.message, "HATA!");
      }
    )
  }

}
